if (!customElements.get('truffle-box-builder')) {
  customElements.define('truffle-box-builder', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.slots = [...this.querySelectorAll('[data-tbb-slot]')];
      this.dialog = this.querySelector('[data-tbb-dialog]');
      this.activeSlot = null;
      this.complete = false;

      this.slots.forEach((slot) => slot.addEventListener('click', () => this.openPicker(slot)));
      this.querySelectorAll('[data-tbb-flavor]').forEach((flavor) => flavor.addEventListener('click', () => this.chooseFlavor(flavor)));
      this.querySelector('[data-tbb-close]')?.addEventListener('click', () => this.dialog.close());
      this.dialog?.addEventListener('click', (event) => { if (event.target === this.dialog) this.dialog.close(); });
      this.form?.addEventListener('submit', (event) => {
        if (this.complete) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        window.alert('Please choose the rest of your truffle flavors before adding to cart.');
      }, true);
      document.addEventListener('zm:item-added', (event) => {
        if (event.detail?.form === this.form) window.alert('Your 8-Piece Truffle Box has been added to cart.');
      });
      this.update();
    }

    openPicker(slot) {
      this.activeSlot = slot;
      this.dialog?.showModal();
      this.querySelector('[data-tbb-flavor]')?.focus();
    }

    chooseFlavor(flavor) {
      if (!this.activeSlot) return;
      const name = flavor.dataset.flavorName;
      const imageUrl = flavor.dataset.flavorImage || '';
      const imageAlt = flavor.dataset.flavorAlt || name;
      this.activeSlot.dataset.flavorName = name;
      this.activeSlot.querySelector('[data-tbb-slot-name]').textContent = name;
      const image = this.activeSlot.querySelector('[data-tbb-slot-image]');
      image.replaceChildren();
      if (imageUrl) {
        const thumbnail = document.createElement('img');
        thumbnail.src = imageUrl;
        thumbnail.alt = imageAlt;
        image.append(thumbnail);
      } else {
        image.textContent = this.activeSlot.dataset.position;
      }
      this.activeSlot.nextElementSibling.value = name;
      this.activeSlot.classList.add('is-complete');
      this.dialog.close();
      this.update();
    }

    update() {
      const selected = this.slots.filter((slot) => slot.dataset.flavorName).length;
      const remaining = 8 - selected;
      this.complete = selected === 8;
      this.querySelector('[data-tbb-count]').textContent = `${selected} of 8 selected`;
      this.querySelector('[data-tbb-remaining]').textContent = remaining
        ? `Choose ${remaining} more ${remaining === 1 ? 'flavor' : 'flavors'}.`
        : 'Your box is ready to add.';
      this.querySelector('[data-tbb-progress]').style.width = `${selected * 12.5}%`;
      this.classList.toggle('is-complete', this.complete);

      const submit = this.form?.querySelector('.product-form__submit');
      if (submit) submit.textContent = this.complete ? 'Add configured box' : 'Complete your box';
    }
  });
}
